/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespNegotiable_item = {
    readonly localizedPdpUrl: string | null;
    readonly displayInfo: {
        readonly ctas: {
            readonly showMakeOffer: boolean | null;
        } | null;
    } | null;
    readonly " $refType": "SbRespNegotiable_item";
};
export type SbRespNegotiable_item$data = SbRespNegotiable_item;
export type SbRespNegotiable_item$key = {
    readonly " $data"?: SbRespNegotiable_item$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespNegotiable_item">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbRespNegotiable_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrade",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "localizedPdpUrl",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "displayInfo",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "isTrade",
          "variableName": "isTrade"
        },
        {
          "kind": "Literal",
          "name": "page",
          "value": "searchAndBrowse"
        }
      ],
      "concreteType": "ItemDisplayInfo",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "ctas",
          "storageKey": null,
          "args": null,
          "concreteType": "CTADisplay",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "showMakeOffer",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = '42ccf8c1e9f55b7279272416e1f59eb3';
export default node;
